module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jules Bennett\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('I', [_vm._v("USA TODAY")]), _vm._v(" Bestselling Author Jules Bennett has penned more than 50 novels during her short career. She's married to her high school sweetheart, has two active girls, and is a former salon owner. Jules can be found on Twitter, Facebook (Fan Page), and her website julesbennett.com. She holds contests via these three outlets with each release and loves to hear from readers!")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LesBFS/tc-custom/9781488062827.jpg?1726519407494",
      "alt": "This image is the cover for the book Unexpected Scandal, Lockwood Lightning"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unexpected Scandal, Lockwood Lightning\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Experience the drama and romance in this passionate workplace romance, part of the Lockwood Lightning series from USA TODAY bestselling author Jules Bennett.  When one late night changes everything!  Billionaire Nick Campbell’s life has been upended. His hated rival is the father he never knew, and his top-notch architect, Silvia Lane, is having his baby. It’s time to regain control. First step: ask Silvia to marry him and claim his heir. But she’s not having it. She has her own plans for how things should go, and she wants real love or nothing!  From Harlequin Desire: Luxury, scandal, desire—welcome to the lives of the American elite.  Lockwood Lightning: Book 1: An Unexpected Scandal Book 2: Scandalous Reunion Book 3: Scandalous Engagement")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0